module.exports = __webpack_public_path__ + "static/media/HomeRoll_Roof_FibreCemRoof.9cdc9ec0.jpg";